/**
 * Shared pieces for the Embla plugins that stack the slides on top of each other
 * instead of scrolling them past the viewport (StackFade, StackSlide).
 *
 * Both keep Embla's flex layout intact — it needs the slides laid out in a row to
 * measure the snap positions — and only move them with transforms afterwards.
 */

// Embla scrolls by translating the container. Stop it, so the slides stay where the
// plugin puts them.
export function disableEmblaScroll(emblaApi) {
	const { translate, slideLooper } = emblaApi.internalEngine()

	translate.clear()
	translate.toggleActive(false)

	slideLooper.loopPoints.forEach((loopPoint) => {
		loopPoint.translate.clear()
		loopPoint.translate.toggleActive(false)
	})
}

/**
 * Transform that parks the slides of a snap on the first slot, shifted by `offset`.
 * Shifting back by the snap's own position is what makes every slide overlap.
 */
export function stackTransform(emblaApi, snapIndex, offset = 0) {
	const { scrollSnaps, axis } = emblaApi.internalEngine()
	const translateAxis = axis.scroll.toUpperCase()
	const position = axis.direction(scrollSnaps[snapIndex] + offset)

	return `translate${translateAxis}(${position}px)`
}

// A snap can hold more than one slide, so always resolve through the registry.
export function slideNodesForSnap(emblaApi, snapIndex) {
	const slideNodes = emblaApi.slideNodes()

	return emblaApi.internalEngine().slideRegistry[snapIndex].map((slideIndex) => slideNodes[slideIndex])
}

// Size of one viewport along the scroll axis — how far off-stage a slide has to sit.
export function viewportSize(emblaApi) {
	const { containerRect, axis } = emblaApi.internalEngine()

	return axis.measureSize(containerRect)
}

export function clearSlideStyles(slideNode, properties) {
	properties.forEach((property) => {
		slideNode.style[property] = ''
	})

	if (!slideNode.getAttribute('style')) {
		slideNode.removeAttribute('style')
	}
}
